/* Keep Judge.me's native sorting; customize only the displayed choices. */
(function () {
  'use strict';
  var labels = {'most-helpful': '参考になった順', 'highest-rating': 'レビュー評価順', 'most-recent': '新着レビュー順'};
  function enhance(select) {
    if (select.dataset.coluluSortReady) return;
    var options = Array.from(select.options);
    if (!Object.keys(labels).every(function (key) { return options.some(function (o) { return o.value === key; }); })) return;
    var selected = select.value;
    var widget = select.closest('.jdgm-widget') || document.documentElement;
    var returning = !!widget.dataset.coluluStandardSort;
    if (!returning) widget.dataset.coluluStandardSort = selected;
    select.dataset.coluluSortReady = 'true';
    var standard = document.createElement('option');
    standard.value = widget.dataset.coluluStandardSort;
    standard.textContent = '標準';
    standard.dataset.coluluStandard = 'true';
    // Standard preserves the app's configured initial order.
    select.replaceChildren(standard);
    Object.keys(labels).forEach(function (key) {
      var option = options.find(function (o) { return o.value === key; });
      option.textContent = labels[key];
      option.selected = false;
      select.appendChild(option);
    });
    select.selectedIndex = returning ? Math.max(0, Array.from(select.options).findIndex(function (o, i) { return i > 0 && o.value === selected; })) : 0;
    select.setAttribute('aria-label', 'レビューの並び替え');
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('select.jdgm-sort-dropdown')) enhance(root);
    root.querySelectorAll('select.jdgm-sort-dropdown').forEach(enhance);
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
  }).observe(document.documentElement, {childList: true, subtree: true});
})();
